module.exports = __webpack_public_path__ + "img/avatar3.2aa344fd.png";